import { c as _c } from "react/compiler-runtime";
import { GroupDetailsInfoBar } from "@components/group-details/group-details-info-bar";
import { useMediaQueryList } from "@hooks/use-media-query";
import { GroupManagersTable } from "@pages/group-details/group-managers-table";
import { useCompanyId } from "@context-providers/company-id-provider";
import { GroupMembersMobileView } from "@pages/group-details/group-members-mobile-view";
import { useGroupMemberBulkActions } from "@pages/group-details/use-group-member-bulk-actions";
import { useDeselectHiddenMembers } from "@pages/group-details/use-deselect-hidden-members";
import { EntitiesToolbar } from "@components/common/toolbar/entities-toolbar";
import { getExportComponent } from "@utils/member-utils";
import { MembersSort } from "@components/table/members/members-sort";
import { useSubjectsSortByQuery } from "@hooks/use-subjects-sort-by-query";
import { DEFAULT_MEMBERS_SORT_BY } from "@components/table/members/members-sort-constants";
import { isMembersSortBy } from "@custom-types/type-guards";
import { EmptyPage } from "@components/common/empty-page/empty-page";
import { MembersDuoIcon } from "@flat-ui";
import { useHasUserValidFeatureCompanyLevel } from "@hooks/feature-control/use-has-user-valid-feature-company-level";
import { useHasUserValidRoleGroupLevel } from "@hooks/access-control/use-has-user-valid-role-group-level";
import { InviteMemberToGroup } from "@pages/group-details/invite-member-to-group";
import { getVisibleGroupMembers } from "@utils/group-utils";
import { useAppSelector } from "@store/store-helper";
import { searchSelector } from "@store/ui/ui-selector";
import { isMemberMatchingSearch } from "@store/members/members-selector";
import { useMembersFilters } from "@components/table/members/members-filters/use-members-filters";
/**
 * Contains the Managers tab of the group details
 */
export function GroupManagers(t0) {
  const $ = _c(55);
  const {
    group,
    isLoading: t1
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const companyId = useCompanyId();
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const {
    canAssignManagers
  } = useHasUserValidFeatureCompanyLevel();
  const t2 = group ?? null;
  let t3;
  if ($[0] !== t2) {
    t3 = {
      selectedGroup: t2
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const {
    canInviteUsersToGroup
  } = useHasUserValidRoleGroupLevel(t3);
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      defaultSort: DEFAULT_MEMBERS_SORT_BY,
      isValidSort: isMembersSortBy
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const {
    sortBy,
    setSortBy
  } = useSubjectsSortByQuery(t4);
  const {
    debouncedSearchText
  } = useAppSelector(searchSelector);
  let hasGroupMembers;
  let t5;
  if ($[3] !== canAssignManagers || $[4] !== debouncedSearchText || $[5] !== group?.members) {
    const groupMembers = getVisibleGroupMembers(group?.members ?? [], canAssignManagers);
    hasGroupMembers = !!groupMembers.length;
    let t6;
    if ($[8] !== debouncedSearchText) {
      t6 = member => isMemberMatchingSearch(member, debouncedSearchText);
      $[8] = debouncedSearchText;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    t5 = groupMembers.filter(t6);
    $[3] = canAssignManagers;
    $[4] = debouncedSearchText;
    $[5] = group?.members;
    $[6] = hasGroupMembers;
    $[7] = t5;
  } else {
    hasGroupMembers = $[6];
    t5 = $[7];
  }
  const searchedMembers = t5;
  let t6;
  if ($[10] !== canAssignManagers || $[11] !== searchedMembers) {
    t6 = {
      members: searchedMembers,
      tableSubject: "group",
      canFilterByRole: canAssignManagers
    };
    $[10] = canAssignManagers;
    $[11] = searchedMembers;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const {
    filteredMembers,
    filterChips
  } = useMembersFilters(t6);
  useDeselectHiddenMembers(filteredMembers);
  let t7;
  if ($[13] !== companyId || $[14] !== filteredMembers || $[15] !== group) {
    t7 = {
      companyId,
      group,
      members: filteredMembers
    };
    $[13] = companyId;
    $[14] = filteredMembers;
    $[15] = group;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const bulkActionButtons = useGroupMemberBulkActions(t7);
  const shouldShowEmptyPage = !canAssignManagers && !isLoading && !!group && !hasGroupMembers;
  let t8;
  if ($[17] !== bulkActionButtons || $[18] !== companyId || $[19] !== filteredMembers || $[20] !== group || $[21] !== isLoading || $[22] !== isScreenSmOrSmaller || $[23] !== setSortBy || $[24] !== sortBy) {
    t8 = isScreenSmOrSmaller ? <GroupMembersMobileView bulkActionButtons={bulkActionButtons} group={group} members={filteredMembers} isLoading={isLoading} sortBy={sortBy} /> : <GroupManagersTable group={group} members={filteredMembers} companyId={companyId} isLoading={isLoading} bulkActionButtons={bulkActionButtons} sortBy={sortBy} setSortBy={setSortBy} />;
    $[17] = bulkActionButtons;
    $[18] = companyId;
    $[19] = filteredMembers;
    $[20] = group;
    $[21] = isLoading;
    $[22] = isScreenSmOrSmaller;
    $[23] = setSortBy;
    $[24] = sortBy;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  const membersContent = t8;
  let t9;
  if ($[26] !== group || $[27] !== isLoading) {
    t9 = <GroupDetailsInfoBar group={group} isLoading={isLoading} />;
    $[26] = group;
    $[27] = isLoading;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  const t10 = canAssignManagers ? "Member" : "Viewer";
  const t11 = filteredMembers.length;
  const t12 = hasGroupMembers ? filterChips : undefined;
  let t13;
  if ($[29] !== canInviteUsersToGroup || $[30] !== group) {
    t13 = canInviteUsersToGroup && group && <InviteMemberToGroup group={group} buttonVariant="filled" />;
    $[29] = canInviteUsersToGroup;
    $[30] = group;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== bulkActionButtons.export || $[33] !== filteredMembers.length) {
    t14 = getExportComponent(filteredMembers.length, bulkActionButtons.export);
    $[32] = bulkActionButtons.export;
    $[33] = filteredMembers.length;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== canAssignManagers || $[36] !== filteredMembers.length || $[37] !== setSortBy || $[38] !== sortBy) {
    t15 = !!filteredMembers.length && <MembersSort sortBy={sortBy} setSortBy={setSortBy} tableSubject="group" hiddenFields={canAssignManagers ? undefined : ["role"]} />;
    $[35] = canAssignManagers;
    $[36] = filteredMembers.length;
    $[37] = setSortBy;
    $[38] = sortBy;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== filteredMembers.length || $[41] !== isLoading || $[42] !== t10 || $[43] !== t12 || $[44] !== t13 || $[45] !== t14 || $[46] !== t15) {
    t16 = <EntitiesToolbar toolbarEntityName={t10} numberOfRows={t11} isLoading={isLoading} filterChips={t12} mobileAction={t13} exportComponent={t14} sortActions={t15} />;
    $[40] = filteredMembers.length;
    $[41] = isLoading;
    $[42] = t10;
    $[43] = t12;
    $[44] = t13;
    $[45] = t14;
    $[46] = t15;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  let t17;
  if ($[48] !== shouldShowEmptyPage) {
    t17 = shouldShowEmptyPage && <EmptyPage title="There are no viewers invited to this group" subtitle="Invite viewers to give them access to this group's projects." icon={MembersDuoIcon} />;
    $[48] = shouldShowEmptyPage;
    $[49] = t17;
  } else {
    t17 = $[49];
  }
  const t18 = !shouldShowEmptyPage && membersContent;
  let t19;
  if ($[50] !== t16 || $[51] !== t17 || $[52] !== t18 || $[53] !== t9) {
    t19 = <>{t9}{t16}{t17}{t18}</>;
    $[50] = t16;
    $[51] = t17;
    $[52] = t18;
    $[53] = t9;
    $[54] = t19;
  } else {
    t19 = $[54];
  }
  return t19;
}